import { get } from 'store/http/httpAction';
import Enums from 'utils/EnumsManager';
import { tryFetchColumns } from 'views/ReportSetup/flow/actions';
import { SET_SETTING_INFO } from './actionTypes';

const { GROUPS, AGGREGATES, OTHERS } = Enums.DROPZONES;
// utils
/**
 * @description extract and parse report settings from response, just in case the response format changes
 * @param {Object} data
 */
const parseSettings = data => {
  if (_.isEmpty(data)) {
    return {
      filters: [],
      logic: '',
      [GROUPS]: [],
      [AGGREGATES]: [],
      [OTHERS]: []
    };
  }
  const {
    filters,
    condition_logic,
    group_by,
    aggregations,
    selectors
  } = data.setup_properties;
  return {
    filters,
    logic: condition_logic,
    [GROUPS]: group_by,
    [AGGREGATES]: aggregations,
    [OTHERS]: selectors
  };
};

const setSettings = settings => ({
  type: SET_SETTING_INFO,
  payload: { settings }
});

export const tryFetchReportSettingsById = reportId => dispatch =>
  get(`/admin/report/${reportId}`, {}, dispatch).then(data => {
    if (data.data) {
      dispatch(tryFetchColumns(data.data.type, reportId));
      dispatch(setSettings(parseSettings(data.data)));
    }
  });



// WEBPACK FOOTER //
// ./src/views/RealTimeReport/flow/actions.js